import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { getAllMedicamentos } from "../../../../api/MedicamentosApi";

const ModalReceta = ({ estado, onCloseModal, onReturnValue, dataEdit }) => {
  const [medicamento, setMedicamento] = useState("");
  const [dosis, setDosis] = useState("");
  const [cantdosis, setCantdosis] = useState("");
  const [doctor, setDoctor] = useState("");
  const [registro, setRegistroDoctor] = useState("");
  const [cantdosisactual, setCantdosisactual] = useState("");
  const [ListMedicamento, setListMedicamento] = useState([]);

  const loaddata = async () => {
    const result = await getAllMedicamentos();
    const resultMapeado = result.map((item) => ({
      label: item.medicamento,
      value: item.medicamento,
    }));
    setListMedicamento(resultMapeado);
  };

  useEffect(() => {
    if (dataEdit) {
      setMedicamento(dataEdit.medicamento || "");
      setDosis(dataEdit.dosis || "");
      setCantdosis(dataEdit.cantdosis || "");
      setDoctor(dataEdit.doctor || "");
      setRegistroDoctor(dataEdit.registro || "");
      setCantdosisactual(dataEdit.cantdosisactual || "");
    } else {
      setMedicamento("");
      setDosis("");
      setCantdosis("");
      setDoctor("");
      setRegistroDoctor("");
      setCantdosisactual("");
    }
    loaddata();
  }, [dataEdit]);

  const handleGuardar = () => {
    // Validate all required fields
    if (
      !medicamento ||
      !dosis ||
      !cantdosis ||
      !doctor ||
      !registro ||
      !cantdosisactual
    ) {
      Swal.fire({
        title: "Datos requeridos",
        text: "Por favor complete todos los campos obligatorios",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
      return;
    }

    const receta = {
      idreceta: dataEdit?.idreceta || null,
      medicamento,
      dosis,
      cantdosis,
      doctor,
      registro,
      cantdosisactual,
    };

    onReturnValue(receta);
  };

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{dataEdit ? "Editar Receta" : "Nueva Receta"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Medicamento</Form.Label>
            <Select
              options={ListMedicamento || []} // Fallback to empty array
              isSearchable
              value={{value: medicamento, label: medicamento}}
              onChange={(e) => setMedicamento(e.value)}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Dosis</Form.Label>
            <Form.Control
              type="text"
              value={dosis}
              required
              onChange={(e) => setDosis(e.target.value)}
              placeholder="Dosis recomendada"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Cantidad dosis</Form.Label>
            <Form.Control
              type="number"
              value={cantdosis}
              required
              onChange={(e) => setCantdosis(e.target.value)}
              placeholder="Número de dosis"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Cantidad dosis faltante</Form.Label>
            <Form.Control
              type="number"
              value={cantdosisactual}
              required
              onChange={(e) => setCantdosisactual(e.target.value)}
              placeholder="Número de dosis faltante"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Doctor</Form.Label>
            <Form.Control
              type="text"
              value={doctor}
              required
              onChange={(e) => setDoctor(e.target.value)}
              placeholder="Nombre del doctor"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>N° de Registro del Doctor</Form.Label>
            <Form.Control
              type="text"
              value={registro}
              required
              onChange={(e) => setRegistroDoctor(e.target.value)}
              placeholder="Registro profesional"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleGuardar}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalReceta;
